import { ListVideoIcon } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";
import { videoCardBadgeStyles } from "@/components/common/video-card/service";

export const PlaylistPreset = ({ data }: { data: PlaylistPreviewVM }) => {
  const { playlistLength } = data;

  return (
    <Badge
      className={cn(
        videoCardBadgeStyles,
        "top-3 right-3 bg-black bg-gradient-to-b from-black to-black text-white",
      )}
    >
      <ListVideoIcon className={"h-4! w-4!"} />
      <div className={"text-xs leading-[1] font-semibold text-white uppercase"}>
        Playlista ({playlistLength})
      </div>
    </Badge>
  );
};
